module.exports = __webpack_public_path__ + "static/AmnestyTradeGothic-ee279478fcdc4e86ba79d1b882905a2b.ttf";